"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVideoTexture = exports.useOffthreadVideoTexture = exports.ThreeCanvas = void 0;
var ThreeCanvas_1 = require("./ThreeCanvas");
Object.defineProperty(exports, "ThreeCanvas", { enumerable: true, get: function () { return ThreeCanvas_1.ThreeCanvas; } });
var use_offthread_video_texture_1 = require("./use-offthread-video-texture");
Object.defineProperty(exports, "useOffthreadVideoTexture", { enumerable: true, get: function () { return use_offthread_video_texture_1.useOffthreadVideoTexture; } });
var use_video_texture_1 = require("./use-video-texture");
Object.defineProperty(exports, "useVideoTexture", { enumerable: true, get: function () { return use_video_texture_1.useVideoTexture; } });
